import { createSlice } from "@reduxjs/toolkit";
import { uniqueId } from "lodash";

const initialState = {
  toasts: []
};

const toastItem = {
  id:'',
  type: "",
  message: ""
};


const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    openToast: (state, action) => {
      const { type, message } = action.payload;
      const id = uniqueId()
      state.toasts = [...state.toasts, { id, type, message }];

    },
    closeToast: (state, action) => {
      const removedId = action.payload
      state.toasts = state.toasts.filter(toast => toast.id !== removedId)
    }
  }
});

export const { openToast, closeToast } = toastSlice.actions;

export default toastSlice;
